export default {
    methods: {
        validateContactEmail (contact) {
            let disableStatus = false;

            if (this.state.user.default_mailbox_id === null) {
                disableStatus = true;
            }

            if (!contact || !contact.email) {
                disableStatus = true;
            } else if (contact && !contact.email) {
                if (!this.validateEmail(contact.email)) {
                    disableStatus = true;
                }

                if (!contact.email_other) {
                    if (contact.always_cc_other) {
                        let otherEmails = contact.email_other.split(",");
                        _.forEach(otherEmails, email => {
                            if (!this.validateEmail(email.trim())) {
                                disableStatus = true;
                            }
                        });
                    }
                }
            }

            return disableStatus;
        }
    }
};